$(document).ready(function () {
  function getWorldTime(tzOffset) {
    var now = new Date();
    var tz =
      now.getTime() + now.getTimezoneOffset() * 60000 + tzOffset * 3600000;
    now.setTime(tz);

    var s =
      leadingZeros(now.getFullYear(), 4) +
      "-" +
      leadingZeros(now.getMonth() + 1, 2) +
      "-" +
      leadingZeros(now.getDate(), 2) +
      " " +
      leadingZeros(now.getHours(), 2) +
      ":" +
      leadingZeros(now.getMinutes(), 2) +
      ":" +
      leadingZeros(now.getSeconds(), 2);

    return s;
  }

  function leadingZeros(n, digits) {
    var zero = "";
    n = n.toString();

    if (n.length < digits) {
      for (i = 0; i < digits - n.length; i++) zero += "0";
    }
    return zero + n;
  }

  var now_addr = window.location.href;
  var preview = now_addr.split("?preview=");
  var preview_ = now_addr.split("&preview=");

  // delay
  if (
    (getWorldTime(+9) > "2025-10-14 10:00:00" &&
      getWorldTime(+9) < "2025-10-22 00:00:00") ||
    preview[1] == "delay" ||
    preview_[1] == "delay"
  ) {
    var prmPdArr = [
      9975739908375
    ];
    for (var i = 0; i <= prmPdArr.length - 1; i++) {
      if ($(".product__title h1").attr("rel") == prmPdArr[i]) {
        $(".product__info-container").after(
          '<div id="ic_notice" class="fs16" style="margin-top:15px; line-height:1.4; color:red"></div>'
        );
        $("#ic_notice").html(
          "🚨 Thank you for your amazing support!<br/>Due to an unexpected surge in demand, some of our items are temporarily out of stock. We apologize for the inconvenience and appreciate your patience as we restock."
        );
      }
    }
  }

  
  
  /* 프로젝트 랜딩 */
  if($('.product__title h1').attr('rel') == 10029667647767 || $('.product__title h1').attr('rel') == 10029665419543){
    $('.header__inline-menu, .yotpo-pictures-widget, .header__icon--account, .sc-divisions, .header__icon--menu, .menu-drawer-container, .rebuy-cart__flyout-recommendations').remove();
    $('.top_slide_bar a, footer a, .header__heading-link').attr('href','#none');

    $('.header').css({'position':'relative', 'display':'flex', 'justify-content':'end'});
    $('.header__heading-link').css({'position':'absolute','left':'50%', 'transform':'translateX(-50%)', 'margin':'0'})

    $('.money_back > div').append('<a href="#none" class="shop_now_btn fs22">SHOP NOW</a>');

    var detail_info_top = $('.product__info-wrapper').offset().top;
    $('.shop_now_btn').click(function(){        
      $("html, body").animate({
          scrollTop: detail_info_top + 'px'
      }, 500);
    })
    
    setInterval(function(){
      $('.rebuy-cart__flyout-recommendations, .rebuy-cart__flyout-empty-cart a, .product__info-container .join-btn').hide();      
    },1000)

  }

  //131_pore_serum_landing
  if($('.product__title h1').attr('rel') == 10033859428631){
    const newStyle = document.createElement('style');
    const cssRules = `
      #randingPosition{font-size:0;text-indent:-9999px;}
      .us_detail_wrap.money_back .money_back_btn{display:inline-block;padding:10px 30px;border:1px solid #fedd72;border-radius:5px;position:absolute;left:50%;transform:translateX(-50%);bottom:30px;color:#fedd72;font-size:24px;font-weight:500;text-decoration:none;}
      @media(max-width:768px){
        .us_detail_wrap.money_back .money_back_btn{padding:5px 10px;border-radius:3px;bottom:20px;font-size:3vw;}
      }
    `;
    newStyle.textContent = cssRules;
    document.head.appendChild(newStyle);

    $(".product__title").after('<div id="randingPosition">randingPosition</div>');
    $(".us_detail_wrap.money_back").append('<a href="#randingPosition" class="money_back_btn">Shop now</a>');

    setInterval(function(){
      $(".yotpo-slider-wrapper").hide();
    },1000);
  }
  

  /* //리뷰 팝업 테스트 */
  //$(".main_vis").remove();

  // shop 리뷰 갯수 반영
  setInterval(function(){
    $(".grid__item").each(function () {
      var bottomline = $(this);

      if (bottomline.hasClass("product__info-wrapper")) return;
      
      var reviewLink = bottomline.find(".yotpo-widget-instance .yotpo-sr-bottom-line-text");
    
      if (reviewLink.length > 0) {
          var reviewText = reviewLink.text(),
              reviewCountMatch = reviewText.match(/\d+/);
    
          if (reviewCountMatch) {
              var reviewCount = reviewCountMatch[0];
              bottomline.find(".rating-count > span").text("(" + reviewCount + ")");
              $(".yotpo-widget-instance").hide();
          }
      }
    });
  }, 100);
  
  /*131앰플 배너*/
  if (getWorldTime(+9) < "2025-07-12 16:00:00"){
    $('#def_vis a').attr('href','/collections/shop-all');
    $('#def_vis .promotion_pc').attr('src','//celladix.us/cdn/shop/files/PC_d3f0cd8c-d596-40ec-a242-def7bb622e37.png?v=1747369228');
    $('#def_vis .promotion_mo').attr('src','//celladix.us/cdn/shop/files/MO_c2ba90ad-f568-4940-820d-68744d681e34.png?v=1747369228');  
  }  

  if (
    (getWorldTime(+9) > "2025-07-08 16:00:00" &&
      getWorldTime(+9) < "2025-07-12 16:00:00") ||
    preview[1] == "true" ||
    preview_[1] == "true"
  ) {
    $(".promotion_bar").show();
    $(".main_vis, #def_vis").hide();
    
    //메인 이미지
    $("#def_vis").before(
      '<div class="promotion_vis"><a href="/collections/shop-all"><img src="https://cdn.shopify.com/s/files/1/0766/4045/2887/files/2025_Amazon_Prime_Day_PC.jpg?v=1751854729" class="promotion_pc"><img src="https://cdn.shopify.com/s/files/1/0766/4045/2887/files/2025_Amazon_Prime_Day_MO.jpg?v=1751854729" class="promotion_mo"></a></div>'
    );
    
    //상세페이지 이미지
    if ($(".skin_area").length > 0) {
      $(".skin_area").before(
        '<div class="promotion_vis"><a href="/collections/shop-all"><img src="https://cdn.shopify.com/s/files/1/0766/4045/2887/files/2025_Amazon_Prime_Day_PC_51321356-a201-49d7-8997-2910ab461a3f.jpg?v=1751861481" class="promotion_pc"><img src="https://cdn.shopify.com/s/files/1/0766/4045/2887/files/2025_Amazon_Prime_Day_MO_375ce672-0c71-41f4-9411-263b151aebff.jpg?v=1751861480" class="promotion_mo"></a></div>'
      );
    }
  } else {    
    $(".promotion_bar").remove();
    $(".main_vis, #def_vis").show();
  }

  //프로모션 start
  if ((getWorldTime(+9) > "2026-10-26 01:00:00" && getWorldTime(+9) < "2026-11-23 01:00:00") || preview[1] == "261022" || preview_[1] == "261022"){
    console.log('프로모션');
    if($(".product .product__title").length > 0){
      $(".icartShopifyCartContent .shopify-section:first-child").after(
        '<div class="promotion_vis"><img src="https://cdn.shopify.com/s/files/1/0677/8657/2012/files/95739dd6d6059bc2839007873a770096.jpg?v=1792711882" class="promotion_pc" style="width:100%;max-width:1465px;margin:0 auto;"><img src="https://cdn.shopify.com/s/files/1/0677/8657/2012/files/95739dd6d6059bc2839007873a770096.jpg?v=1792711882" class="promotion_mo" style="width:100%;max-width:1465px;margin:0 auto;"></div>'
      );
    }
    $(".new_slide_bnr .prm").removeClass("displaynone"); 
    $(".new_slide_bnr .prm .promotion_pc,.new_slide_bnr .prm .promotion_mo").css('background-position-y','bottom'); 


    // 비밀링크 상세페이지 썸네일 변경
    if ($('.product__info-container').length) {
      console.log('fkfkfkfk');
        if ($('.product__title h1[rel="9413911478508"]').length) {
            const newImgSrc = 'https://cdn.shopify.com/s/files/1/0677/8657/2012/files/S.jpg?v=1792711886';

            // 메인 이미지 변경
            $('.gallery-top .swiper-slide:first-child .product__media img').attr({
                src: newImgSrc,
                srcset: ''
            });

            // 하단 썸네일 첫 번째 이미지 변경
            $('.gallery-thumbs .swiper-slide:first-child img').attr({
                src: newImgSrc,
                srcset: ''
            });
        }
    }
  }else{
    $(".new_top_bar, .new_slide_bnr .prm").remove(); 
  }
  //프로모션 end
  

  $(document).ready(function () {
    for (var i = 1; i <= $(".product-grid .grid__item").length; i++) {
      var originPrice = $(
        ".product-grid  .grid__item:nth-child(" + i + ") #orign_p"
      )
        .attr("rel")
        .replace(/,/g, ""); //.replace(/,/g, "")
      var rate = $(".product-grid  .grid__item:nth-child(" + i + ") #real_p")
        .attr("rel")
        .replace(/,/g, "");
      var savePrice = Math.round(100 - (rate * 100) / originPrice);
      console.log(originPrice, rate, savePrice);
      $(".product-grid .grid__item:nth-child(" + i + ") .sale_bd").text(
        "Save " + savePrice + "%"
      );

      $('.sale_bd[rel="8623362703639"]').text("Save 37%");
      $('.sale_bd[rel="8623418605847"]').text("Save 49%");
      $('.sale_bd[rel="8623422308631"]').text("Save 58%");
      $('.sale_bd[rel="8623425716503"]').text("Save 49%");
      
    }
  });
});


// 이미지
/*
var img1 = '1_29b9132f-1652-4968-a032-cf9d553e4a1e.jpg'; 
var img2 = '1_a69752f0-30a5-411e-93c1-c0782e537b7d.jpg';
var img3 = '1_45b530ac-55ce-4789-9496-ee56925bafc4.jpg';
var img4 = '1_7797e6f3-933c-466c-8f29-334824e0190b.jpg'; 
var img5 = '1_a67fc76f-c0a1-4e3b-98af-c9377a9db0b1.jpg';
var img6 = '1_673225ad-0dff-4321-a3c6-98192797f64f.jpg';
var img7 = '1_069288ed-b5f6-463f-8405-90c25e7e93d6.jpg'; 
var img8 = '1_d53f5f83-5cf4-42ce-98dd-20c4f86260b1.jpg';
var img9 = '1_34b93b8c-d188-49d4-ab6e-2fcc32b0aa01.jpg';


setInterval(function(){
    for(var i = 1; i <= $('img').length; i++){
        var imgElements = document.getElementsByTagName('img');
        
        if ($(imgElements[i]).attr('src') !== undefined) {
            var imgSrc = imgElements[i].getAttribute('src');
        }else if ($(imgElements[i]).attr('data-src') !== undefined) {
            var imgDataSrc = imgElements[i].getAttribute('data-src');                    
        }
        if(imgSrc.includes(img1)){      
            imgElements[i].setAttribute('srcset','https://cdn.shopify.com/s/files/1/0766/4045/2887/files/131__Msa3_Ayj5_b3d4724c-f11d-47a4-95dc-880470c60971.jpg?v=1703048227');
        }else if(imgSrc.includes(img2)){   
            imgElements[i].setAttribute('srcset','https://cdn.shopify.com/s/files/1/0766/4045/2887/files/131__Msa3_Ayj5_dd033241-fdb5-41ce-a68c-b20db2a9b10d.jpg?v=1703048228');              
        }else if(imgSrc.includes(img3)){   
            imgElements[i].setAttribute('srcset','https://cdn.shopify.com/s/files/1/0766/4045/2887/files/131__Msa3_Ayj5_04c49234-64b6-4c82-b368-53c81535c1c1.jpg?v=1703048227');              
        }else if(imgSrc.includes(img4)){   
            imgElements[i].setAttribute('srcset','https://cdn.shopify.com/s/files/1/0766/4045/2887/files/131__Msa3_Ayj5_ead7da39-5792-43de-a652-82f7ad71c672.jpg?v=1703048228');              
        }else if(imgSrc.includes(img5)){   
            imgElements[i].setAttribute('srcset','https://cdn.shopify.com/s/files/1/0766/4045/2887/files/cef__Msa3_Ayj5_16b43bed-5fd5-4c9f-b980-43e585d390b2.jpg?v=1703048227');              
        }else if(imgSrc.includes(img6)){   
            imgElements[i].setAttribute('srcset','https://cdn.shopify.com/s/files/1/0766/4045/2887/files/Msa3_Ayj5_c22edb73-79ff-465f-b74c-bdbe1c36165d.jpg?v=1703048227');              
        }else if(imgSrc.includes(img7)){   
            imgElements[i].setAttribute('srcset','https://cdn.shopify.com/s/files/1/0766/4045/2887/files/Msa3_Ayj5_1ec00fd3-78db-4a0b-b790-d350d9bbe8c6.jpg?v=1703048227');              
        }else if(imgSrc.includes(img8)){   
            imgElements[i].setAttribute('srcset','https://cdn.shopify.com/s/files/1/0766/4045/2887/files/Msa3_Ayj5_33e59164-09ac-46e3-aaeb-62d663aec1b2.jpg?v=1703048227');              
        }else if(imgSrc.includes(img9)){   
            imgElements[i].setAttribute('srcset','https://cdn.shopify.com/s/files/1/0766/4045/2887/files/Msa3_Ayj5_2dade045-a9cb-48c8-a7d4-dae4beade57c.jpg?v=1703048227');              
        }
    }
},200)
*/

//131 앰플 상세페이지 문안 추가
// if($('.product__title h1').attr('rel') == 9975739908375){
//   $(".buy_btn").after(
//     '<div class="detail_notice_box" style="margin:20px 0;">'+
//       '<strong style="color:#252e8e;font-size:24px;">Delivery Delay Notice</strong>'+
//       '<p style="color:#000;font-size:16px;line-height:20px;margin:10px 0 0;">Due to increased order volume during our Prime Day Promotion (7.8 – 7.11), shipments of 131 Pore Clearing Serum may be delayed by up to 7 additional business days beyond the standard delivery timeframe.<br>We’re doing our best to get your order to you as quickly as possible.Thank you for your patience and understanding!</p>'+
//     '</div>'
//   );
// }


